module.exports = __webpack_public_path__ + "static/step5_203-5aa2e89cdbd841b53da4166b6c9bffc2.png";